// extracted by mini-css-extract-plugin
export var blue = "bt_dj";
export var dark = "bt_cw";
export var gold = "bt_dk";
export var gray = "bt_dl";
export var iconMain = "bt_dq";
export var light = "bt_ct";
export var magenta = "bt_dp";
export var none = "bt_dm";
export var orange = "bt_dn";
export var original = "bt_dh";
export var root = "bt_dg";
export var tan = "bt_ch";